import { useNavigate } from "react-router-dom";
import { Container } from "semantic-ui-react";
import Header from "components/header";

import { GameStats, GetAllProfiles } from "./profileLoader";
import HeroTable from "./heroTable";

const HeroRanks = () => {
    const navigate = useNavigate();

    const profiles = GetAllProfiles();

    var combinedHeroDicts: {
        [hero: string]: GameStats;
    } = {};

    Object.values(profiles).forEach((profile) => {
        console.log(profile);
        Object.entries(profile.hero_stats_dict).forEach(([hero, stats]) => {
            if (combinedHeroDicts[hero]) {
                combinedHeroDicts[hero].win_count += stats.win_count;
                combinedHeroDicts[hero].lose_count += stats.lose_count;
            } else {
                combinedHeroDicts[hero] = {...stats};
            }
        });
    });

    return (
        <div className="melee-wrapper">
            <Container
                className="regular-text"
                style={{ paddingTop: 10, paddingBottom: 10 }}
            >

                <Header
                    helmet={"Player Ranks"}
                    rightMenu={
                        <button
                            className="melee-inline-button"
                            onClick={() => navigate("/")}
                        >
                            Back
                        </button>
                    }
                />

                <div style={{ marginTop: "4em", marginBottom: "4em" }}>
                    <h2 style={{ marginBottom: '3em' }}>Heroes</h2>
                    
                    <HeroTable heroes={combinedHeroDicts}/>
                </div>
            </Container>
        </div>
    );
}

export default HeroRanks;